module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("1 ")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chapter01"
    }
  }, [_c('p', {
    staticClass: "chap-num"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Table_of_contents"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-ttl"
  }, [_c('a', {
    attrs: {
      "href": "#/Table_of_contents"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("‘In the beginning God created the heavens and the earth.’ So the book of Genesis itself begins – a beginning about a beginning in which a Person (God) sets the cosmos in motion. This is where the story starts, by addressing three fundamental human questions: "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Was")]), _vm._v(" there a beginning? Are we living in a creation? Who created? The scale of this story, we understand immediately, will be grand; the questions that it seeks to answer will be huge. Why do we encounter the world as an ordered place in which life flourishes? Where do human beings fit into the scheme of things? How are they supposed to live, and what are they supposed to do? Why is there evil in the world, and why is there suffering? What is God doing in the cosmos to rescue it from evil and suffering? How do Abraham and his descendants fit into that plan? The storyteller – traditionally Moses – is nothing if not ambitious. So far as we can tell, those who preceded him were content to pass on smaller accounts of narrower matters – a story about Cain and Abel, for example (now related in Genesis 4), or a genealogy of the descendants of Adam down to Noah and his sons (now found in Genesis 5)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn1-1",
      "id": "tn1-1"
    }
  }, [_vm._v("1")])]), _vm._v(" Perhaps some stories had already been collected into larger cycles of stories about particular characters, like Jacob."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn1-2",
      "id": "tn1-2"
    }
  }, [_vm._v("2")])]), _vm._v(" These resources are now gathered up together, however, and woven into a coherent and sustained account of the universe and of ancient Israel’s place within it, which continues beyond the confines of Genesis into the remainder of the Pentateuch, and then into the subsequent narrative books of the Old Testament (OT) (Joshua to Kings). Ancient myths, genealogies, etiologies, and other stories – all are deployed in this astonishingly bold project.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "epub-semibold-normal-normal"
  }, [_vm._v("The structure of Genesis")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("These various resources have been incorporated into the book of Genesis by means of a particular structuring device – a repeated pattern of words "), _c('a', {
    attrs: {
      "id": "p2"
    }
  }, [_vm._v("that marks off one section of Genesis from another, often referred to in modern biblical scholarship as the ‘"), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("toledot")]), _vm._v(" formulae’. In Hebrew, the words are "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("’elleh toledot")]), _vm._v(", and these words have been translated into English in a number of ways, including ‘these are the generations of’, ‘this is the family history of’, and ‘this is the account of’. They always stand at the beginning of the section of the book to which they refer, and they are almost always followed by a personal name, as in Genesis 6.9, ‘This is the family history of Noah.’ The person named after the ‘formula’, however, is not necessarily the main character in the section of Genesis that follows it, which is often much more about his "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("descendants")]), _vm._v(". The account of Terah’s line, for example, hardly mentions Terah himself; it concerns, centrally, Abraham and his family (Genesis 11.27—25.11).")])]), _c('a', {
    attrs: {
      "id": "p2"
    }
  }, [_c('p', {
    staticClass: "chap-bm"
  }, [_vm._v("There are 11 "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("toledot")]), _vm._v(" formulae in total, dividing Genesis into 11 sections (which I shall refer to as ‘acts’ in an unfolding drama), to which we must add a twelfth – since we must account for the material in Genesis 1.1—2.3 that precedes the first ‘formula’. We may outline the structure of the book in the following manner, therefore:")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("1.1—2.3 ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("(1) Prologue")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("2.4—4.26 ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("(2) The ‘family history’ of the heavens and the earth: Adam, Eve, Cain and Abel, down to Seth and Enosh. This is the only exception to the rule about a personal name following "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("’elleh toledot")]), _vm._v(". Here the cosmos itself is imagined as the progenitor of the human race, no doubt because Adam emerges from the ‘womb’ of the ground (Hb. "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("’adamah")]), _vm._v(", Gen. 2.7).")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("5.1—6.8 ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("(3) The family history of Adam down to Noah, prior to the great flood")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("6.9—9.29 ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("(4) The family history of Noah, whose family survives the flood, down to Shem, Ham and Japheth (and Ham’s son Canaan)")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("10.1—11.9 ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("(5) The family history of Shem, Ham and Japheth: the origins of the nations after the flood, including the account of the scattering at Babel")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("11.10–26 ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("(6) The family history of Shem")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("11.27—25.11")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("(7) The family history of Terah: his son Abraham and his family")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("25.12–18 ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("(8) The family history of Ishmael, Abraham’s ‘unchosen’ son")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("25.19—35.29 ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("(9) The family history of Isaac, Abraham’s chosen son")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_c('a', {
    attrs: {
      "id": "p3"
    }
  }, [_vm._v("36.1–8 ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("(10) The family history of Esau, Isaac’s ‘unchosen’ son")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("36.9—37.1 ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("(11) A second account of the family history of Esau")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("37.2—50.26 ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("(12) The family history of Jacob, Isaac’s chosen son: the 12 brothers, especially Judah and Joseph")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("It is important to note that the endpoints of each of the ‘acts’ marked off by "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("toledot")]), _vm._v(" formulae represent important transitions in the story of Genesis:")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("4.26 ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("‘At that time men began to call on the name of the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v("’ – the beginning of the worship of Yahweh, which prepares us for Noah")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("6.8 ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("‘Noah found favour in the eyes of the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v("’ – Noah is identified as a worshipper of Yahweh, which will be crucial in the story of the flood")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("9.29 ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("‘Altogether, Noah lived 950 years, and then he died’ – the end of the ‘old world’ and the point of transition into ‘the world and its peoples as we know them now’ in Genesis 10 (the descendants of Shem, Ham and Japheth)")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("11.9 ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("‘The L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" scattered them over the face of the whole earth’ – the context for the story of the line of Shem")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("11.26 ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("‘Terah . . . became the father of Abram’ – the transition into the Abraham story")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("25.11 ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("‘After Abraham’s death, God blessed his son Isaac’ – the transition from Abraham to his ‘unchosen’ son, Ishmael")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("25.18 ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("‘His [Ishmael’s] descendants settled in the area from Havilah to Shur’ – the transition back into the chosen line of Isaac")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("35.29 ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("‘[Isaac] breathed his last and died’ – the transition from Isaac into the story of his ‘unchosen’ son, Esau")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("36.8 ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("‘Esau (that is, Edom) settled in the hill country of Seir’ – the "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("anticipated")]), _vm._v(" transition back to the chosen line of Jacob")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("37.1 ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("‘Jacob lived in the land where his father had stayed, the land of Canaan’ – the "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("actual")]), _vm._v(" transition back to the chosen line of Jacob")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("50.26 ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("‘Joseph died at the age of a hundred and ten’ – the transition into the story of the exodus from Egypt")])])])])])]), _c('p', {
    staticClass: "chap-bm-first"
  }, [_c('a', {
    attrs: {
      "id": "p2"
    }
  }), _c('a', {
    attrs: {
      "id": "p4"
    }
  }, [_vm._v("The curiosity in this structure is the double account of Esau’s line. Because it disturbs the normal pattern in the book, most commentators have regarded the second account in Genesis 36.9—37.1 as having been inserted into the text after its basic shape had already been established. It is not easy to imagine why this addition might have been made, however. Was it perhaps to bring the total number of ‘acts’ in the book up to the number 12 – the traditional number of the Israelite tribes? Did it perhaps have something to do with the importance of Edom in biblical thought as a crucial player in the advent of messianic rule in the world?"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn1-3",
      "id": "tn1-3"
    }
  }, [_vm._v("3")]), _vm._v(" We can only guess.")]), _vm._v(" "), _c('p', {
    staticClass: "chap-bm"
  }, [_vm._v("The "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("toledot")]), _vm._v(" formulae, then, explicitly indicate the overall structure of the book of Genesis. Within the various acts in the drama, moreover, a plausible case can often be made for the presence of further structuring devices. For example, Bruce Waltke regards the Jacob cycle of stories in Genesis 25.19—35.22 (most of Act 9) as possessing what he calls a ‘concentric pattern’:")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/fig1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("Waltke also regards the Abraham and Joseph cycles as having the same concentric pattern – like a ‘chiastic’ pattern, but possessing a double rather than a single centre (F and F"), _c('span', {
    staticClass: "epub-medium-normal-normal"
  }, [_vm._v("′")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn1-4",
      "id": "tn1-4"
    }
  }, [_vm._v("4")])]), _vm._v(" Certainly chiasmus is a well-established literary reality in the OT, and others have argued for it persuasively in other parts of Genesis. Gordon Wenham has tried to show, for example, that the story of the great flood in Genesis 6.10—8.19 appears in chiastic form (he calls it a ‘palistrophe’), the waters rising until God remembers "), _c('a', {
    attrs: {
      "id": "p5"
    }
  }, [_vm._v("Noah in Genesis 8.1, after which they begin to recede."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn1-5",
      "id": "tn1-5"
    }
  }, [_vm._v("5")]), _vm._v(" Wenham represents the matter thus:")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/fig2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("In seeking such smaller structures within Genesis we are, of course, inevitably working at a more hypothetical level than in the case of the larger "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("toledot")]), _vm._v("-structure for the whole book. These hypotheses often appear to cast light, however, on otherwise opaque aspects of the text. In the case "), _c('a', {
    attrs: {
      "id": "p6"
    }
  }, [_vm._v("of the flood story, for example, the presence of a palistrophe helps to explain some redundancy in the text. For example, the period of ‘seven days’ waiting for embarkation in the ark is mentioned twice, in Genesis 7.4 and 7.10, even though it seems that only one period of time is in view. Why? Wenham suggests that this is a matter of literary necessity: the author requires in the first half of the palistrophe a parallel (H and I) to the two seven-day periods in the second, where the ark’s inhabitants are waiting for the floodwaters to subside (Gen. 8.10, 12; I"), _c('span', {
    staticClass: "epub-medium-normal-normal"
  }, [_vm._v("′")]), _vm._v(" and H"), _c('span', {
    staticClass: "epub-medium-normal-normal"
  }, [_vm._v("′")]), _vm._v("). In narrative reality we are dealing in the first case with one week, and in the second with two weeks, but the chosen structure forces the author to ‘duplicate’ the first time-period.")])]), _c('a', {
    attrs: {
      "id": "p6"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "epub-semibold-normal-normal"
  }, [_vm._v("The story of Genesis")])])]), _c('p', {
    staticClass: "chap-bm-first"
  }, [_c('a', {
    attrs: {
      "id": "p6"
    }
  }, [_vm._v("How does the story of Genesis unfold within this overall structure? Here I am simply going to outline the story, not describe it in any great detail. I shall be unpacking this outline in more depth in ")]), _c('span', {
    attrs: {
      "href": "#/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapters 5")]), _vm._v("—"), _c('span', {
    attrs: {
      "href": "#/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" below.")]), _vm._v(" "), _c('p', {
    staticClass: "chap-bm"
  }, [_vm._v("The book of Genesis begins, of course, with the story of the early history of the earth as a whole (Gen. 1—11) – often labelled by scholars as ‘the Primeval History’. The Prologue in Genesis 1.1—2.3 describes, first, the creation of the world. The earth and everything within it is characterized here as the good creation of a personal God, using the working week (six days, followed by a Sabbath) as its governing metaphor. Creation reaches its apex, first, in the creation of the land animals and human beings on the sixth day, and then in the resting of God on the seventh day. The human creatures are given an especially important role in creation as the ‘image-bearers’ of God: as well as multiplying in number like the other creatures, they are to ‘rule’ the earth and ‘subdue it’ (Gen. 1.28). This is the language of kingship; it denotes that God has delegated governance functions in the cosmos to men and women.")]), _vm._v(" "), _c('p', {
    staticClass: "chap-bm"
  }, [_vm._v("Act 2 of Genesis begins by exploring this human role in creation further. Now, however, the humans are not presented as kings, but as priests – set in God’s garden ‘to work it and take care of it’ (2.15). If in Genesis 1 humans appear ‘late’ on the scene, arriving to govern a kingdom that has already been created and is functioning well, in Genesis 2 they appear early, before any ‘shrub [has] yet appeared on the earth’ and before any ‘plant [has] yet sprung up’ (2.5); they are created in order to enable creation as a whole to function as God intended. Taking Genesis 1 and 2 together, it appears that human beings exist both as the apex and as the centre of creation, created both to govern and to serve in a paradise in "), _c('a', {
    attrs: {
      "id": "p7"
    }
  }, [_vm._v("which there is ‘no shame’ (Gen. 2.25). Their relationships with God, with each other and with the other creatures are good.")])]), _c('a', {
    attrs: {
      "id": "p7"
    }
  }, [_c('p', {
    staticClass: "chap-bm"
  }, [_vm._v("In Genesis 3, something goes wrong with this good creation. Created by God to live in harmony with him and with each other – to be ‘one flesh’ (2.24) and to look after each other’s interests – human beings lose touch with God and with each other. The man blames God for what has happened (‘the woman you put here with me’, 3.12), and also blames the woman herself; the woman blames the serpent, who first seduced her into eating the fruit of the forbidden tree (the tree of the knowledge of good and evil, 3.13). In pursuit of immortality, they have grasped at knowledge they should not yet have possessed (3.5). Thus it is, claims Genesis 3, that moral evil entered human experience in God’s good world. The consequences are serious. Barred from the tree of life and the garden in which it sits (2.22–24), humans have now lost the path to the immortality they so deeply craved. Now they turn in on themselves, and become locked into a struggle for power – the man seeking to dominate the woman, and the woman desiring to get the better of the man (3.16). The struggle is not just with the other, but also with the dark cosmic forces that tempted them to evil in the first place (3.15). It does not just affect their marriage, either; it affects their family, as well as their ability to gain sustenance from the ground (3.16–19).")])]), _c('p', {
    staticClass: "chap-bm"
  }, [_c('a', {
    attrs: {
      "id": "p7"
    }
  }, [_vm._v("In Genesis 4 the family difficulties are illustrated. If husbands and wives are in conflict in Genesis 3, now we also discover that brother hates brother. Cain’s jealousy of Abel puts him in a dangerous place, as God warns him that sin ‘is crouching at your door; it desires to have you, but you must master it’ (4.7). However, Cain ignores the warning and succumbs to evil; he kills his brother, failing to act instead as his ‘keeper’ (4.9). From this moment onwards, down until Noah’s time, evil works its way ever more deeply into human society, even as we read of significant advances in technology and culture (4.17–24). Life goes on; "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("human beings")]), _vm._v(" go on, being fruitful and multiplying, even in the midst of considerable wrongdoing (Gen. 5). Eventually, however, ‘man’s wickedness on the earth’ is so great that God determines to bring an end to all life – or virtually so. The last statement of Act 3 of Genesis (5.1—6.8) hints that at least Noah may be spared, for he alone ‘found favour in the eyes of the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v("’ (6.8). It is left to Act 4 to expand on this understated verse, as Genesis 6.9—9.29 go on to describe the unusual boat in which Noah will survive the great flood that is coming – Noah, his family and representatives of all the living things that depend to some extent on dry land (including birds). Some of these animals are taken on board to ensure the survival of their species, ")]), _c('a', {
    attrs: {
      "id": "p8"
    }
  }, [_vm._v("others to serve as sacrificial victims in worship after the flood is over (7.2; 8.20).")])]), _c('a', {
    attrs: {
      "id": "p8"
    }
  }, [_c('p', {
    staticClass: "chap-bm"
  }, [_vm._v("The rains ultimately fall and the floodwaters rise, until the point at which God remembers Noah (8.1); then they recede. Noah and all those with him disembark from the boat, and life begins anew, with a commitment by God never again to curse the ground, destroy all living creatures or disrupt the normal cycles of nature (8.21–22). This is followed by a covenant between God and Noah that solemnly establishes the matter. Here the creation mandate that was addressed to human beings in Genesis 1 is reissued (9.1, 7), although certain adjustments are made to the resources that human beings may use for food (9.2–3), reflecting the new situation in the world. The commitments that God announces in Genesis 8 and 9 are necessary if the human story is to continue, for human nature (we read) has not changed in the midst of the flood: ‘every inclination of his heart is evil from childhood’ now as it was before (8.21; cf. 6.5). This truth is immediately illustrated, as Act 4 ends, by the strange story of Noah’s sons and their reaction to his ‘nakedness’ (9.18–29).")]), _vm._v(" "), _c('p', {
    staticClass: "chap-bm"
  }, [_vm._v("Act 5 introduces the family lines of Noah’s sons, and it ambitiously attempts to draw a map of the entire ancient world and its peoples (Gen. 10.1—11.9). Act 6 briefly recounts the family line of Shem, the forefather of Abraham. Life still goes on, it tells us; people are still being fruitful and multiplying. Sandwiched between the genealogies here we find a brief account of the happenings at the tower of Babel (11.1–9), which is designed to illustrate that human nature has "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("indeed")]), _vm._v(" not changed as a result of the great flood. People may still be multiplying, but they are not ‘filling the earth’ (Gen. 9.1); instead, they have chosen to settle down in one place, with the intention of making ‘a name’ for themselves. Elsewhere in the OT, it is only God who rightly makes a ‘name’ for himself (e.g. Isa. 63.11–14). These are human beings, then, striving to be ‘like God’ in a wrong way – the ‘original sin’ of Genesis 3. This attempt at human solidarity in opposition to God inevitably fails, and the people involved are scattered ‘over the face of the whole earth’ (Gen. 11.9).")])]), _c('p', {
    staticClass: "chap-bm"
  }, [_c('a', {
    attrs: {
      "id": "p8"
    }
  }, [_vm._v("The Primeval History comes to an end in Genesis 11.26, and we transition immediately in Act 7 into the story of Israel as such. The line of Shem (the ‘Semitic’ peoples) eventually produces Terah, the immediate ancestor of Abraham, whose story occupies the remainder of Genesis 11.27––25.11. It is significant that Terah’s family comes "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("out of")]), _vm._v(" the same Babylonia in which the famous tower was previously built. God’s response to the fragmentation of the human race at Babel, in this story, is to take up one fragment of this race and give it a promise of land and nationhood (Gen. ")]), _c('a', {
    attrs: {
      "id": "p9"
    }
  }, [_vm._v("12.1–2). He will ‘make great’ Abraham’s ‘name’, even as he opposed those who wanted to make their "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("own")]), _vm._v(" name great in Babylon. God’s ultimate goal, it seems, is that all the earth may still receive the blessing that he originally intended in creation (12.3). Genesis 12.1–13, then, is presented as a response to what happens in Genesis 1—11; the story of Abraham’s descendants is bound up with the story of the whole earth.")])]), _c('a', {
    attrs: {
      "id": "p9"
    }
  }), _c('p', {
    staticClass: "chap-bm"
  }, [_c('a', {
    attrs: {
      "id": "p9"
    }
  }, [_vm._v("It is this promise to Abraham that occupies centre stage for most of the remainder of the Pentateuch."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn1-6",
      "id": "tn1-6"
    }
  }, [_vm._v("6")]), _vm._v(" The book of Genesis informs us, first, about various things that happened to Abraham and his immediate descendants, Isaac and Jacob, in relation to this promise. The Promised Land is identified in chapters 12 and 13 as Canaan (12.5–7; 13.14–17); the identity of the descendant through whom the promise of nationhood will be realized remains a mystery for a little longer. At first it seems that it might be Ishmael, Abraham’s son by the concubine Hagar (Gen. 16). However, by the time that Ishmael’s family history is summarized in Act 8 (Gen. 25.12–18), the reader knows that this is not so. Isaac is the chosen son, born to Sarah in her old age and growing up to survive a threat to his life at the hands of his own father (Gen. 22).")]), _vm._v(" "), _c('p', {
    staticClass: "chap-bm"
  }, [_vm._v("The story of Isaac’s family is then recounted in Act 9 (Gen. 25.19—35.29). Here it becomes especially clear for the first time in the account of Abraham’s descendants that the divine promise is under threat not only from the barrenness of various women in the story (Gen. 18.10–15; 25.21), nor merely from the desires of several of its powerful men (12.10–20). The promise is also under threat from the moral character of God’s people themselves – people who, like Cain before them, fail to love their neighbours (and, especially, their brothers). Jacob, Isaac’s son, steals first of all his brother Esau’s birthright (his inheritance) and then Esau’s blessing from Isaac (a blessing that "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("should")]), _vm._v(" have been given to the firstborn). This leads on eventually to Jacob’s exile from the Promised Land (Gen. 28) and an education in cheating in a foreign one (Gen. 29), before he eventually returns, a new man with a new name, and is reconciled with his brother (Gen. 32—33).")]), _vm._v(" "), _c('p', {
    staticClass: "chap-bm"
  }, [_vm._v("After the double account of the family history of Esau that follows in Acts 10 and 11 (Gen. 36.1 to 37.1), the book of Genesis comes to a conclusion in Act 12 with the family history of Jacob (37.2—50.26). The overtly central character in this part of the story, the privileged and irritating Joseph, is so hated by his brothers that they beat him up, throw him "), _c('a', {
    attrs: {
      "id": "p10"
    }
  }, [_vm._v("into a pit and later sell him into slavery in Egypt. Brothers, again, fail to love their brother. In Egypt, however, Joseph rises to a position of power, protecting the country from the worst aspects of a serious famine and ultimately encountering his brothers again when they arrive in Egypt in search of food. Reconciliation follows, and thus there is, in a way, a happy ending to the book of Genesis.")])]), _c('a', {
    attrs: {
      "id": "p10"
    }
  }, [_c('p', {
    staticClass: "chap-bm"
  }, [_vm._v("However, it is striking that "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("by")]), _vm._v(" the end of this story we have progressed only a very little further in terms of the earlier divine promise to Abraham. Genesis 46.27 tells us that all the persons of the house of Jacob that came into Egypt were 70 – not exactly as many descendants as the stars of heaven (15.5) or the sand of the sea (22.17). And, of course, these people are in "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Egypt")]), _vm._v(" – they are not in Canaan, which is still almost entirely in the possession of the Canaanites (note Gen. 23.17–20; 33.19 for the exceptions). The promise appears to have run aground in the sands of a foreign land. It will require the later departure from Egypt that is described in the book of Exodus, and all the events described thereafter in Leviticus and Numbers, to get Abraham’s descendants back even to the borders of the Promised Land, where they still sit as the Pentateuch ends in the book of Deuteronomy. It is not until many generations later, under King David and King Solomon, that the promise is even somewhat fulfilled in all its various aspects, by which time it has become clear that the most important character in Act 12 of Genesis is perhaps not Joseph after all, but his brother Judah (Gen. 38; 49.8–12).")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "epub-semibold-normal-normal"
  }, [_vm._v("The distinctiveness of Genesis")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("When measured against the other books in the Pentateuch, Genesis reveals itself to possess some distinctive features. It is almost entirely narrative, whereas the remaining books are characterized by extensive sections that are explicitly instructional and indeed legal in character. The Genesis narratives themselves are focused for the most part on a small extended family or clan, and not on what we might rightly call a people group or a nation (as in Exodus through Deuteronomy). The exception is Genesis 1—11, which tells an even larger story than the remainder of the Pentateuch – the story of the world at large prior to Abraham’s time. It is not only the focus of Genesis that is distinctive here, but also the substance; Genesis 1—11 is far more obviously and extensively in dialogue with its ancient Near Eastern context – its literature, rituals and religious perspectives – than the remainder of the Pentateuch, and indeed the remainder of Genesis itself.")])]), _c('p', {
    staticClass: "chap-bm"
  }, [_c('a', {
    attrs: {
      "id": "p10"
    }
  }), _c('a', {
    attrs: {
      "id": "p11"
    }
  }, [_vm._v("When we reach Genesis 12—50, we discover various other features of Genesis that mark it out from the books that follow. For example, we encounter many names and customs that never recur later in the biblical story (e.g. the name ‘Mamre’, Gen. 13.18; the custom of taking a concubine as a solution to the problem of childlessness, Gen. 16.2). God himself is named using the composite ‘Yahweh Elohim’ (‘L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" God’), which only otherwise appears in the Pentateuch in Exodus 9.30. Some of what the patriarchs believe and do is in fact in explicit contradiction to what the remainder of the Pentateuch teaches. Gordon Wenham notes a number of such examples in his Genesis commentary."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fn1-7",
      "id": "tn1-7"
    }
  }, [_vm._v("7")]), _vm._v(" Abraham marries his half-sister (Gen. 20.12) and Jacob marries two sisters (29.21–30), whereas Leviticus 18.9, 11, 18 and 20.7 condemn both practices. Judah and Simeon marry Canaanites and Joseph an Egyptian, a practice condemned in Exodus 34.16 and Deuteronomy 7.3. Both Isaac and Jacob give the lion’s share of their inheritance to junior sons, a practice contrary to the rules given in Deuteronomy 21.15–17. As to religious practice,")]), _vm._v(" "), _c('p', {
    staticClass: "ext-only"
  }, [_vm._v("the patriarchs do indulge in worship practices that later generations regarded as improper. They erect pillars, pour libations over them, and plant trees (28:18, 22; 35:14; 21:33), whereas Deut 12:2–3 condemns worship ‘upon the hills under every green tree’ and commends the uprooting of pillars and Asherim.")]), _vm._v(" "), _c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("There is, indeed, none of the religious tension in Genesis 12—50 between God’s people and their neighbours that marks the later story. It is not without reason, then, that Genesis can be referred to as ‘the Old Testament of the Old Testament’."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fn1-8",
      "id": "tn1-8"
    }
  }, [_vm._v("8")])]), _vm._v(" It is a quite distinctive book.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote-line"
  }, [_vm._v("________________")]), _vm._v(" "), _c('p', {
    staticClass: "fn-0"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#tn1-1",
      "id": "fn1-1"
    }
  }, [_vm._v("1")])]), _vm._v(" R. W. L. Moberly, "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("The Theology of the Book of Genesis")]), _vm._v(" (OTT; Cambridge: Cambridge University Press, 2009), 22–8; B. K. Waltke, "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Genesis: A Commentary")]), _vm._v(" (Grand Rapids: Zondervan, 2001), 24–8.")]), _vm._v(" "), _c('p', {
    staticClass: "fn-0"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#tn1-2",
      "id": "fn1-2"
    }
  }, [_vm._v("2")])]), _vm._v(" H. Gunkel, "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Genesis")]), _vm._v(" (trans. of the 1910 ed. by M. E. Biddle; Macon: Mercer University, 1997), vii–xlviii.")]), _vm._v(" "), _c('p', {
    staticClass: "fn-0"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#tn1-3",
      "id": "fn1-3"
    }
  }, [_vm._v("3")])]), _vm._v(" See Obad. 21; Num. 24.18; Amos 9.12 (cf. Acts 15.17).")]), _vm._v(" "), _c('p', {
    staticClass: "fn-0"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#tn1-4",
      "id": "fn1-4"
    }
  }, [_vm._v("4")])]), _vm._v(" Waltke, "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Genesis")]), _vm._v(", 19–21. Waltke is building here on earlier work by G. A. Rendsburg, "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("The Redaction of Genesis")]), _vm._v(" (Winona Lake: Eisenbrauns, 1986), and D. A. Dorsey, "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("The Literary Structure of the Old Testament: A Commentary on Genesis–Malachi")]), _vm._v(" (Grand Rapids: Baker, 1999).")]), _vm._v(" "), _c('p', {
    staticClass: "fn-0"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#tn1-5",
      "id": "fn1-5"
    }
  }, [_vm._v("5")])]), _vm._v(" G. J. Wenham, ‘The Coherence of the Flood Narrative’, "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("VT")]), _vm._v(" 28 (1978): 336–48.")]), _vm._v(" "), _c('p', {
    staticClass: "fn-0"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#tn1-6",
      "id": "fn1-6"
    }
  }, [_vm._v("6")])]), _vm._v(" D. J. A. Clines, "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("The Theme of the Pentateuch")]), _vm._v(" (JSOTSup 10; 2nd ed.; Sheffield: Sheffield Academic Press, 1997).")]), _vm._v(" "), _c('p', {
    staticClass: "fn-0"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#tn1-7",
      "id": "fn1-7"
    }
  }, [_vm._v("7")])]), _vm._v(" G. J. Wenham, "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Genesis 16–50")]), _vm._v(" (WBC; Dallas: Word, 1994), xxv, xxxiv.")]), _vm._v(" "), _c('p', {
    staticClass: "fn-0"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#tn1-8",
      "id": "fn1-8"
    }
  }, [_vm._v("8")])]), _vm._v(" R. W. L. Moberly, "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("The Old Testament of the Old Testament: Patriarchal Narratives and Mosaic Yahwism")]), _vm._v(" (OBT: Minneapolis: Fortress, 1992).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a3769f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter01.vue
// module id = 78
// module chunks = 0